import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static targets = [ "onlyDate", "onlyTime", "dateTime" ]
  connect() {
  }

  onlyDateTargetConnected(element) {
    flatpickr(element, {
      enableTime: false,
      // displaying with format <short month>, <day>, <year>
      // May 30, 1976
      dateFormat: "M j, Y",
      disable: [
        function (date) {
          // return true to disable
          // return date.getDay() === 0 || date.getDay() === 6;
        },
      ],
      locale: {
        firstDayOfWeek: 0, // start week on Monday
      },
    });
  }
  
  onlyTimeTargetConnected(element) {
    flatpickr(element, {
      noCalendar: true,
      enableTime: true,
      // displaying with format hours:minutes AM/PM
      // 12:00 PM
      dateFormat: "h:i K",
    })
  }
  
  dateTimeTargetConnected(element) {
    flatpickr(element, {
      enableTime: true,
      // displaying with format <short month>, <day>, <year>
      // May 30, 1976
      dateFormat: "M j, Y h:i K",
      disable: [
        function (date) {
          // return true to disable
          // return date.getDay() === 0 || date.getDay() === 6;
        },
      ],
      locale: {
        firstDayOfWeek: 0, // start week on Monday
      },
    })
  }  
}
